import * as Sentry from "@sentry/react";

import { beforeSendFilterResponses } from './sentry-config-helpers'

Sentry.init({
  release: import.meta.env.VITE_COMMIT_HASH,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  attachStacktrace: true,
  tracesSampleRate: import.meta.env.VITE_SENTRY_ENVIRONMENT.includes('prod') ? 0.05 : 1.0,
  beforeSend: beforeSendFilterResponses,
});
